import TableCellDateDebut from '../../Components/Includes/Table/TableCellDateDebut'

export const debut = {
  id: "debut",
  sort: true,
  padding: true,
  label: "Début",
  component: TableCellDateDebut
}
